import { addCommonBlock, addCommonBlockFile } from 'client/actions/blockActions'
import * as blockApi from 'client/api/blockApi'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { useActions } from 'common/hooks/useActions'
import { BaseEntityNewInterface } from 'src/shared/schemas/base-entity.schema'

interface CreateCommonBlockParams {
  locale: PageLocaleEnum
  blockEntities: BaseEntityNewInterface[]
  desktopBlobFile: string
  mobileBlobFile: string
  title: string
  category: string
}

export const useCreateCommonBlock = () => {
  const addBlock = useActions(addCommonBlock)
  const addCommonFile = useActions(addCommonBlockFile)

  const createCommonBlock = async ({
    locale,
    blockEntities,
    desktopBlobFile,
    mobileBlobFile,
    title,
    category,
  }: CreateCommonBlockParams) => {
    const { data } = await blockApi.createCommonBlock(
      locale,
      blockEntities,
      desktopBlobFile,
      mobileBlobFile,
      title,
      category,
    )
    addBlock(data.block)
    addCommonFile(data.desktopPreview)
    addCommonFile(data.mobilePreview)
    return data
  }

  return {
    createCommonBlock,
  }
}
